/* eslint-disable no-underscore-dangle */
export var LOG_TYPE_INFO = 'INFO';
export var LOG_TYPE_CORE = 'CORE';
export var LOG_TYPE_EXTENDED = 'EXTENDED';
export var LOG_TYPE_ERROR = 'ERROR';
export var SUCCESS = 'SUCCESS';
export var FAILED = 'FAILED';
export var INITIALIZING = 'Initializing plugin';
export var INITIALIZING_FAILED = 'Failed to initialize plugin';
export var FIRE_CALLBACK = 'Fired CMP callback';
export var GET_CONSENTS_REQUEST = 'Updating consents';
export var GET_CONSENTS_FAILED = 'Cannot get user consents';
export var VENDORS_LIST = 'Vendors list';
export var GET_VENDORS_LIST = 'Getting vendors list';
export var GET_OTHER_VENDORS_LIST = 'Getting other vendors list';
export var GET_VENDORS_LIST_FAILED = 'Cannot get Vendors List';
export var GET_OTHER_VENDORS_LIST_FAILED = 'Cannot get Other Vendors List';
export var CMP_CHANGES = 'tcString has changed: ';
export var CMP_NO_CHANGES = 'No changes';
export var CMP_NO_CHANGES_MESSAGE = "No update in necessary as tcString hasn't changed";
export var ADD_LISTENERS = 'Adding listeners';
export var ADD_LISTENERS_ALREADY_DONE = 'Listeres were already active';
export var LOAD_CUSTOM_ADVERTIZERS = 'Loading custom advertisers';
export var LOAD_CUSTOM_ADVERTIZERS_SUCCESS = 'Custom advertisers consents';
export var LOAD_CUSTOM_ADVERTIZERS_FAILED = 'Loading custom advertisers';
export var ADD_PIXEL = 'Adding partner pixel';
export var ADD_PIXEL_SUCCESS = 'Added partner pixel';
export var REMOVING_PIXEL = 'Removing partner pixel';
export var LOAD_CONSENT = 'Loading consent';
export var LOAD_CONSENT_FAILED = 'Could nor get consent for';
export var CHANGE_GOOGLE = 'Google consent is';
export var LOAD_GOOGLE_IDS = 'Fetching Google Vendors IDs';
export var LOAD_GOOGLE_IDS_FAILED = 'Could not get Google Vendors IDs';
export var REJECTED_BY_PURPOSES = 'rejected by one of its purposes';
export var NO_VENDOR_FOUND = 'No vendor found on IAB database with the id';
export var CROSS_CHECK_VENDOR = 'Cross checking vendor';
export var CROSS_CHECK_VENDOR_FAILED = 'Could not get cross referenced consent for vendor';
export var INJECT_SCRIPT = 'Injecting script';
export var UPDATE_COMSCORE = 'Updated Comscore object';
export var ADD_HASH_ID = 'Adding TrackUser HashId';
export var CONSENT_READY = 'Consent Ready';
export var CONSENT_CHANGED = 'Consent Changed';
var LOG_LEVEL_INFO = 'info';
var LOG_LEVEL_ERROR = 'error';
var LOG_LEVEL_EXTENDED = 'extended';
export var cmpLog = function cmpLog(logType, message) {
  var level;
  var type;
  var color;

  switch (logType) {
    case LOG_TYPE_CORE:
      level = LOG_LEVEL_INFO;
      type = LOG_TYPE_CORE;
      color = 'color: rebeccapurple; font-weight: bold;';
      break;

    case LOG_TYPE_EXTENDED:
      level = LOG_LEVEL_INFO;
      type = LOG_TYPE_EXTENDED;
      color = 'color: black; font-weight: bold;';
      break;

    case LOG_TYPE_ERROR:
      level = LOG_LEVEL_ERROR;
      type = LOG_TYPE_ERROR;
      color = 'color: black; font-weight: bold;';
      break;

    default:
      level = LOG_LEVEL_INFO;
      type = logType;
      color = 'color: teal; font-weight: bold;';
      break;
  } // if (true || window.__debug_cmp__ || logType === LOG_TYPE_CORE) {


  if (window.__debug_cmp__ || !window.__debug_cmp__) {
    var _console;

    var date = new Date();
    var formatDate = "".concat("00".concat(date.getMonth() + 1).slice(-2), "/").concat("00".concat(date.getDate()).slice(-2), "/").concat(date.getFullYear(), " ").concat("00".concat(date.getHours()).slice(-2), ":").concat("00".concat(date.getMinutes()).slice(-2), ":").concat("00".concat(date.getSeconds()).slice(-2));

    if ( // false &&
    logType === LOG_TYPE_EXTENDED && window.__debug_cmp__ !== LOG_LEVEL_EXTENDED) {
      return;
    } // eslint-disable-next-line no-console


    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    (_console = console)[level].apply(_console, ["%c[CMP] ".concat(type, ": ").concat(message, " "), color, formatDate].concat(args));
  }
};
export var logResults = function logResults(vendorName, consentObject) {
  if (consentObject.consent) {
    cmpLog(LOG_TYPE_INFO, "".concat(vendorName.toUpperCase(), " consent accepted"), consentObject);
  } else if (!consentObject.vendor) {
    cmpLog(LOG_TYPE_CORE, "".concat(vendorName.toUpperCase(), " consent accepted by default"), consentObject);
  } else if (consentObject.restrictions) {
    cmpLog(LOG_TYPE_CORE, "".concat(vendorName.toUpperCase(), " consent not given"), consentObject.restrictions);
  } else {
    cmpLog(LOG_TYPE_CORE, "".concat(vendorName.toUpperCase(), " consent not given"), 'Vendor rejected', consentObject);
  }
};